angular.module('SpidApp')

.factory('RandomStringGenerator', [function () {
    return function (size) {
        if (size < 1) {
            throw 'RandomStringGenerator() - Bad parameters'
        }
        
        size = size || 8
        
        var CHARS = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
        
        var generatedString = []
        
        for(var i = 0 ; i < size ; i++) {
            var rand = Math.floor(Math.random() * CHARS.length)
            
            generatedString.push( CHARS[rand] )
        }
        
        return generatedString.join('')
    }
}])
